module.exports = __webpack_public_path__ + "static/DC1-0ce70909c12e62f09820f905870e02f6.jpg";